const PUBLIC_KEY_B64 =
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0RLGK+0DlggSr22Vsh/4xpUAbAchKLbxtuh+HXYoaI7r+ucfYrjehPehBB13Pw4tPxyFQE1G8rIKfuAMqzCEJ7Njg9DoRdDhsuHgKyw7SAjRZJw4LseSleO+WUnz8XC1E647eutCqeXSiNLYuxzEOYbrUZ2SrAO+jQ6zf0xf6uG0YGjgQ7h8Gv56bz1c6ciDz2Qvw7oJ4g/Q0I19w0+KoJ9C6aMQeE1UMmx+9CsTRKqlI8eo47lkEOECLtoHsi8ohnmWvcsKRLhdHva+LB0aKW0jNclllHFxTarWrIxTbHlC3PVP6viONGVocKby6+dRz6ewmbq/gRF+tKLoMmXOQwIDAQAB'

/**
 * Encrypt credit card data using RSA-OAEP SHA-256 (Web Crypto API).
 * Returns base64-encoded encrypted string for ccEncrypted field.
 */
export async function encryptCreditCard(cardNumber: string, expiry: string, cvv: string): Promise<string> {
    const plaintext = `${cardNumber}|${expiry}|${cvv}`

    const keyBytes = Uint8Array.from(atob(PUBLIC_KEY_B64), c => c.charCodeAt(0))

    const publicKey = await window.crypto.subtle.importKey('spki', keyBytes.buffer, { name: 'RSA-OAEP', hash: 'SHA-256' }, false, ['encrypt'])

    const encrypted = await window.crypto.subtle.encrypt({ name: 'RSA-OAEP' }, publicKey, new TextEncoder().encode(plaintext))

    return btoa(String.fromCharCode(...new Uint8Array(encrypted)))
}
